const featuresData = [
  {
    title: '海量资源库',
    desc: '电影、剧集、综艺、动漫、纪录片全覆盖，10万+影视资源每日更新扩充，总有你想看的',
    icon: 'ri-database-2-line',
  },
  {
    title: '高清流畅播',
    desc: '多线CDN加速技术保障，1080P高清画质不缓冲不卡顿，WiFi和移动网络都能畅快观影',
    icon: 'ri-4k-line',
  },
  {
    title: '全终端覆盖',
    desc: '支持网站、APP多端访问，数据同步，在家用电脑、出门用手机，无缝切换观影体验',
    icon: 'ri-device-line',
  },
  {
    title: '安全无广告',
    desc: '绿色纯净观影环境，无弹窗骚扰、无强制广告、无恶意跳转，专注内容本身',
    icon: 'ri-shield-check-line',
  },
];

const updatesData = [
  { date: '2026-07-30', text: '片库新增院线大片《星际征途2》《深海迷踪》等20余部高清资源' },
  { date: '2026-07-28', text: '热门韩剧《月光下的秘密》第12集已更新，中文字幕同步上线' },
  { date: '2026-07-26', text: '黄桃视频APP iOS版本更新至v3.2.1，优化播放器性能和缓存体验' },
  { date: '2026-07-24', text: '纪录片专区新增BBC《地球脉动》系列全三季高清完整版' },
  { date: '2026-07-22', text: '国产剧《长安风云录》全集上线，豆瓣8.7分古装权谋大剧' },
  { date: '2026-07-20', text: '动漫新番《星之彼方》每周日更新，日语中字同步' },
  { date: '2026-07-18', text: '服务器全面升级完成，全站播放速度提升30%，观影更流畅' },
  { date: '2026-07-16', text: '综艺《笑林大会》第三季开播，搞笑艺人齐聚笑点不断' },
];

const topicsData = [
  { tag: '热门电影', count: '2.8w', color: 'bg-primary-100 text-primary-700' },
  { tag: '韩剧推荐', count: '1.6w', color: 'bg-accent-100 text-accent-700' },
  { tag: '国产好剧', count: '2.1w', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '动漫新番', count: '1.9w', color: 'bg-primary-100 text-primary-700' },
  { tag: '综艺爆笑', count: '1.3w', color: 'bg-accent-100 text-accent-700' },
  { tag: '纪录片精选', count: '8.6k', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '短剧上瘾', count: '1.1w', color: 'bg-primary-100 text-primary-700' },
  { tag: '悬疑推理', count: '9.2k', color: 'bg-accent-100 text-accent-700' },
  { tag: '科幻巨制', count: '7.8k', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '古装美学', count: '1.5w', color: 'bg-primary-100 text-primary-700' },
  { tag: '免费观影', count: '3.2w', color: 'bg-accent-100 text-accent-700' },
];

const rankingData = [
  { rank: 1, title: '长安风云录', meta: '古装权谋 · 豆瓣8.7', icon: 'ri-fire-line', iconColor: 'text-red-500' },
  { rank: 2, title: '月光下的秘密', meta: '韩剧爱情 · 热播中', icon: 'ri-fire-line', iconColor: 'text-orange-500' },
  { rank: 3, title: '星际征途2', meta: '科幻大片 · 新上线', icon: 'ri-star-fill', iconColor: 'text-accent-500' },
  { rank: 4, title: '笑林大会S3', meta: '搞笑综艺 · 爆笑来袭', icon: 'ri-emotion-laugh-line', iconColor: 'text-primary-500' },
  { rank: 5, title: '星之彼方', meta: '日漫新番 · 每周更新', icon: 'ri-rocket-2-line', iconColor: 'text-accent-500' },
  { rank: 6, title: '深海迷踪', meta: '悬疑惊悚 · 口碑佳作', icon: 'ri-moon-line', iconColor: 'text-secondary-500' },
];

const contactData = {
  title: '联系我们',
  desc: '如有内容建议、合作意向或使用问题，欢迎通过以下方式与我们取得联系。黄桃视频团队将尽快回复您的反馈。',
  email: 'contact@huangtao.video',
  sections: [
    { title: '内容建议', desc: '对片库内容有建议或需求？告诉我们你想看什么，我们会尽力满足。', icon: 'ri-mail-send-line' },
    { title: '合作洽谈', desc: '版权合作、广告投放、渠道推广等商务合作，欢迎来信详谈。', icon: 'ri-briefcase-line' },
    { title: '问题反馈', desc: '使用过程中遇到任何问题，请详细描述，技术团队会及时处理。', icon: 'ri-bug-line' },
  ],
};

export function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              平台优势
            </h2>
            <p className="mt-3 text-base text-foreground-600">为什么选择黄桃视频</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {featuresData.map((f) => (
              <div key={f.title} className="text-center p-6 rounded-2xl bg-background-50 border border-background-200/70">
                <span className="inline-flex w-14 h-14 rounded-2xl bg-primary-100 items-center justify-center mb-4">
                  <i className={`${f.icon} text-primary-500 text-2xl`}></i>
                </span>
                <h3 className="text-base font-semibold text-foreground-950">{f.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新动态
            </h2>
            <p className="mt-3 text-base text-foreground-600">黄桃视频内容与功能更新快讯</p>
          </div>
          <div className="relative pl-8 border-l-2 border-background-200 space-y-8">
            {updatesData.map((u, i) => (
              <div key={i} className="relative">
                <span className="absolute -left-[33px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></span>
                <span className="text-xs text-foreground-500 font-medium">{u.date}</span>
                <p className="mt-1 text-sm text-foreground-700 leading-relaxed">{u.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门话题
            </h2>
            <p className="mt-3 text-base text-foreground-600">看看大家都在讨论什么</p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {topicsData.map((t) => (
              <span
                key={t.tag}
                className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium cursor-pointer transition-all duration-200 hover:scale-105 ${t.color}`}
              >
                {t.tag}
                <span className="text-xs opacity-70">{t.count}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门榜单
            </h2>
            <p className="mt-3 text-base text-foreground-600">本周最受欢迎影视内容排行</p>
          </div>
          <div className="space-y-3">
            {rankingData.map((item, i) => (
              <div
                key={item.title}
                className="flex items-center gap-4 p-4 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
              >
                <span className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center text-base font-bold ${
                  i < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 mt-0.5">{item.meta}</p>
                </div>
                <span className="flex-shrink-0">
                  <i className={`${item.icon} ${item.iconColor} text-lg`}></i>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              联系我们
            </h2>
            <p className="mt-3 text-base text-foreground-600 max-w-xl mx-auto">{contactData.desc}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
            {contactData.sections.map((s) => (
              <div key={s.title} className="text-center p-6 rounded-2xl bg-background-50 border border-background-200/70">
                <span className="inline-flex w-12 h-12 rounded-xl bg-primary-100 items-center justify-center mb-3">
                  <i className={`${s.icon} text-primary-500 text-xl`}></i>
                </span>
                <h3 className="text-base font-semibold text-foreground-950">{s.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center p-8 rounded-2xl bg-background-50 border border-background-200/70">
            <p className="text-sm text-foreground-600 mb-3">官方联系邮箱</p>
            <a
              href={`mailto:${contactData.email}`}
              className="inline-flex items-center gap-2 text-xl font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              {contactData.email}
            </a>
            <p className="mt-4 text-xs text-foreground-500">工作日 9:00-18:00，通常24小时内回复</p>
          </div>
        </div>
      </div>
    </section>
  );
}